import { HttpErrorResponse } from "@angular/common/http";
import { GigotErrorResponse } from "../model/error/gigot-error-response.error";
import { Optional } from "./optional.model";
import { TypeSystem } from "./type-system.support";

	/**
	 * @description
	 *	Provee un resultado para un modal o cuadro de diálogo en la UI. El
	 *	formato es genérico, con lo cual permite uniformar la lógica de los
	 *	componentes que lo usen.
	 */

export class DialogResult<T = typeof TypeSystem.EmptyObject> {

	public message: string = "La operación fue realizada con éxito";
	public ok: boolean = true;
	public payload: T = undefined;

	public constructor(initialization?: Partial<DialogResult<T>>) {
		Object.assign(this, initialization);
	}

	/**
	 * @description
	 *	Produce un resultado con falla. Opcionalmente, se puede proveer un
	 *	error de la aplicación con el cual producir un mensaje más acorde y
	 *	específico. En caso de no proveer este tipo de error, se producirá un
	 *	error genérico.
	*/
	public static withFailure<T = any>(response?: GigotErrorResponse<T>): DialogResult<T> {
		return Optional.of(response)
			.filter(response => response.isGigotException)
			.map(response => new DialogResult<T>({
				message: response.error.message,
				ok: false,
				payload: response.error.payload
			}))
			.getOrElse(new DialogResult({
				message: `La operación falló y no se pudo realizar. ${(response as HttpErrorResponse).error.errorMessage}.`,
				ok: false
			}));
	}
}
